Vendd.Scripts.load(function () {

	var googleMaps = {
		apiUrl: 'https://maps.google.com/maps/api/',
		apiKey: LhApp.Context.Site.GoogleMapsKey,
		language: LhApp.Context.Language,
		region: LhApp.Context.Country,
		callback: 'callback_googlemaps',
		request: undefined,
		useViewport: false
	}

	var googleMapOptions = {
		disableDefaultUI: true,
		zoomControl: true,
		mapTypeControl: false,
		fullscreenControl: false
	};

	var googleMapsLoaded = false;
	var warehouseSelectorContext = undefined;

	function init(context) {
		var $context = $(context);
		var $wrapper = $('.x-warehouse-selector-popup-step-one_C', $context);

		if ($wrapper.length < 1) {
			return;
		}

		var wrapper = $wrapper.get(0),
			$root,
			$map,
			$locateButton,
			$address,
			$addressButton,
			$submitButton,
			map,
			marker;

		var state = {
			geolocationAccessDenied: false,
			address: undefined,
			locationId: undefined
		};

		wrapper.init = function () {
			$root = $('.warehouse-selector-popup-step-one', $wrapper);
			$map = $('.map-container', $root);
			$locateButton = $('.js-locate', $root);
			$address = $(':input[name="address"]', $root);
			$addressButton = $('.js-lookup', $root);
			$location = $(':input[name="location"]', $root);
			$submitButton = $('.js-submit', $root);

			/* NOTE: The 'geolocationAccessDenied' field should not be updated after a re-init. */
			state.address = $address.val() || '';
			state.locationId = $location.selectedVal();

			wrapper.initMap();
			wrapper.moveMarkerToLocation(wrapper.getSelectedLocation());
			wrapper.updateViewState();
		};

		wrapper.initMap = function () {
			if (!map) {
				var mapOptions = $.extend({}, googleMapOptions);

				var mapZoom = parseFloat($map.data('map-zoom'));
				var mapLatitude = parseFloat($map.data('map-latitude'));
				var mapLongitude = parseFloat($map.data('map-longitude'));

				if (!isNaN(mapZoom)) {
					mapOptions = $.extend(mapOptions, {
						zoom: mapZoom
					});
				}
				if (!isNaN(mapLatitude) && !isNaN(mapLongitude)) {
					mapOptions = $.extend(mapOptions, {
						center: {
							lat: mapLatitude,
							lng: mapLongitude
						}
					});
				}

				map = new google.maps.Map($map.get(0), mapOptions);
				map.addListener('click', wrapper.onMapClick);
			}

			if (!marker) {
				var markerOptions = {
					draggable: true
				};

				marker = new google.maps.Marker(markerOptions);
				marker.addListener('dragend', wrapper.onMarkerDragEnd);
			}
		};

		wrapper.updateViewState = function () {
			$locateButton.toggleDisabled(state.geolocationAccessDenied);
			$addressButton.toggleDisabled(state.address === '');
			$submitButton.toggleDisabled(state.locationId === undefined);
		};

		wrapper.loading = function (status) {
			if (status === undefined) {
				return $wrapper.hasClass('x-loading');
			}
			else {
				$wrapper.toggleClass('x-loading', status);
			}
		};

		wrapper.getSelectedLocation = function () {
			var $selectedLocation = $location.filter('[value="' + state.locationId + '"]');
			return convertDataToModel($selectedLocation.data());
		};

		wrapper.moveMarkerToLocation = function (location) {
			if (location) {
				var position = new google.maps.LatLng({
					lat: location.Coordinates.Latitude,
					lng: location.Coordinates.Longitude
				});

				var isVisible = marker.getMap() && marker.getPosition();

				marker.setTitle(location.Address);
				marker.setPosition(position);
				marker.setMap(map);

				if (!isVisible) {
					/* Avoid using panTo(...) method until the map initializes and becomes 
					 * visible to the user; use setCenter(...) instead. */
					map.setCenter(position);
					map.setZoom(18);
				}
				else if (location.Viewport && googleMaps.useViewport) {
					map.fitBounds({
						south: location.Viewport.Southwest.Latitude,
						west: location.Viewport.Southwest.Longitude,
						north: location.Viewport.Northeast.Latitude,
						east: location.Viewport.Northeast.Longitude
					});
				}
				else {
					map.panTo(position);
					map.setZoom(18);
				}
			}
			else {
				marker.setMap(null);
				marker.setPosition(null);
			}

			wrapper.updateViewState();
		}

		wrapper.updateMarkerPosition = function (position) {
			if (position) {
				marker.setPosition(position);
				marker.setMap(map);
				wrapper.reverseGeocode();
			}
			else {
				marker.setMap(null);
				marker.setPosition(null);
			}

			wrapper.updateViewState();
		};

		wrapper.updateAddress = function (address) {
			if (state.address !== address) {
				state.address = address;
				wrapper.geocode();
				wrapper.updateViewState();
			}
		};

		wrapper.updateLocationId = function (locationId) {
			if (state.locationId !== locationId) {
				state.locationId = locationId;
				wrapper.moveMarkerToLocation(wrapper.getSelectedLocation());
				wrapper.updateViewState();
			}
		};

		wrapper.updateAndSelectLocationSuggestion = function (location) {
			var items = [{ IsSelected: true, Value: location }];
			var model = { Items: items };
			var html = Vendd.Handlebars.parse("warehouseSelectorLocationSelector_A", model);
			$('.x-warehouse-selector-location-selector', $root).html(html);
			wrapper.init();
		}

		wrapper.updateLocationSuggestions = function (locations) {
			var items = $.map(locations, function (location) {
				return { IsSelected: false, Value: location };
			});
			var model = { Items: items };
			var html = Vendd.Handlebars.parse("warehouseSelectorLocationSelector_A", model);
			$('.x-warehouse-selector-location-selector', $root).html(html);
			wrapper.init();
		}

		/* Google geocoding and reverse-geocoding services */

		wrapper.geocoding = function (status) {
			if (status === undefined) {
				return $wrapper.hasClass('x-geocoding');
			}
			else {
				$wrapper.toggleClass('x-geocoding', status);
			}
		}

		wrapper.reverseGeocoding = function (status) {
			if (status === undefined) {
				return $wrapper.hasClass('x-reverse-geocoding');
			}
			else {
				$wrapper.toggleClass('x-reverse-geocoding', status);
			}
		}

		wrapper.geocode = function () {
			wrapper.cancelGeocode();

			if (state.address === '') {
				return;
			}

			googleMaps.request = $.ajax({
				url: googleMaps.apiUrl + 'geocode/json',
				type: 'GET',
				data: {
					key: googleMaps.apiKey,
					language: googleMaps.language,
					region: googleMaps.region,
					address: state.address,
				},
				beforeSend: function (jqXHR) {
					wrapper.geocoding(true);
				},
				complete: function (jqXHR, status) {
					googleMaps.request = undefined;
					wrapper.geocoding(false);
				},
				error: function (jqXHR, status, error) {
					if (status === 'abort') {
						return; /* User cancelled request  ignore. */
					}
					console.log('' + error);
				},
				success: function (data, status, jqXHR) {
					if (data && data.status === 'OK' && data.results && data.results.length > 0) {
						var model = convertPlacesToModel(data.results);
						if (model.length === 1) {
							wrapper.updateAndSelectLocationSuggestion(model[0]);
						}
						else if (model.length > 1) {
							wrapper.updateLocationSuggestions(model);
						}
					}
					else if (data && data.error_message) {
						toastr.error(data.error_message);
					}
				}
			});
		}

		wrapper.reverseGeocode = function () {
			wrapper.cancelGeocode();

			if (!marker.getMap()) {
				return;
			}

			googleMaps.request = $.ajax({
				url: googleMaps.apiUrl + 'geocode/json',
				type: 'GET',
				data: {
					key: googleMaps.apiKey,
					language: googleMaps.language,
					region: googleMaps.region,
					latlng: marker.getPosition().toUrlValue()
				},
				beforeSend: function (jqXHR) {
					wrapper.reverseGeocoding(true);
				},
				complete: function (jqXHR, status) {
					googleMaps.request = undefined;
					wrapper.reverseGeocoding(false);
				},
				error: function (jqXHR, status, error) {
					if (status === 'abort') {
						return; /* User cancelled request  ignore. */
					}
					console.log('' + error);
				},
				success: function (data, status, jqXHR) {
					if (data && data.status === 'OK' && data.results && data.results.length > 0) {
						var model = convertPlacesToModel(data.results);
						if (model.length) {
							wrapper.updateAndSelectLocationSuggestion(model[0]);
						}
						else {
							wrapper.updateLocationSuggestions([]);
						}
					}
					else if (data && data.error_message) {
						toastr.error(data.error_message);
					}
				},
			});
		}

		wrapper.cancelGeocode = function () {
			if (googleMaps.request !== undefined) {
				googleMaps.request.abort();
				googleMaps.request = undefined;
			}
		};

		/* Event handlers */

		wrapper.onMapClick = function (e) {
			wrapper.updateMarkerPosition(e.latLng);
		};

		wrapper.onMarkerDragEnd = function (e) {
			wrapper.updateMarkerPosition(e.latLng);
		};

		$wrapper.on('click', '.js-locate', function (e) {
			e.preventDefault();

			if (navigator.geolocation) {
				navigator.geolocation.getCurrentPosition(
					function (position) {
						var latLng = new google.maps.LatLng({
							lat: position.coords.latitude,
							lng: position.coords.longitude,
						});
						wrapper.updateMarkerPosition(latLng);
					},
					function (error) {
						toastr.error(error.message);
						state.geolocationAccessDenied = true;
						wrapper.updateViewState();
					}
				);
			}
		});

		$wrapper.on('click', '.js-lookup', function (e) {
			e.preventDefault();
			wrapper.geocode();
		});

		$wrapper.on('change', ':input[name="address"]', function () {
			wrapper.updateAddress($address.val());
		});

		$wrapper.on('keyup', ':input[name="address"]', function (e) {
			e.preventDefault();
		});

		$wrapper.on('keyup', ':input[name="address"]', $.debounce(500, function () {
			wrapper.updateAddress($address.val());
		}));

		$wrapper.on('change', ':input[name="location"]', function (e) {
			e.preventDefault();
			wrapper.updateLocationId($location.selectedVal());
		});

		$wrapper.on('click', '.js-submit', function (e) {
			e.preventDefault();
			wrapper.loading(true);
			Vendd.MessageBus.publish(wrapper, new Vendd.WarehouseSelector.Messages.GetStoresByLocation(
				wrapper.getSelectedLocation()
			));
		});

		Vendd.MessageBus.subscribe(Vendd.WarehouseSelector.Messages.GetStoresSuccess, wrapper, function () {
			wrapper.loading(false);
		});

		Vendd.MessageBus.subscribe(Vendd.WarehouseSelector.Messages.GetStoresFailed, wrapper, function () {
			wrapper.loading(false);
			/* TODO: Shall we provide additional error handling? */
		});

		wrapper.init();
	}

	Vendd.MessageBus.subscribe(Vendd.Widget.Messages.BindControl, 'x-warehouse-selector-popup-step-one_C', function (envelope) {
		if (envelope.message.data.context === 'x-warehouse-selector-popup') {
			warehouseSelectorContext = envelope.sender;

			installScript({
				src: googleMaps.apiUrl + 'js?key=' + googleMaps.apiKey + '&language=' + googleMaps.language + '&callback=' + googleMaps.callback,
				async: true,
				defer: true
			});

			if (googleMapsLoaded) {
				init(warehouseSelectorContext);
			}
		}
	});

	Vendd.MessageBus.subscribe(Vendd.Plugins.Messages.GoogleMapsLoaded, 'x-warehouse-selector-popup-step-one_C', function (envelope) {
		googleMapsLoaded = true;

		if (warehouseSelectorContext) {
			init(warehouseSelectorContext);
		}
	});


	/* Helpers */

	function installScript(options) {
		var baseUrl = options.src.match(/[^?]*/)[0]; /* Absolute URL without the query part. */

		if (!$('script[src^="' + baseUrl + '"]').length) {
			/* console.log('[WarehouseSelector] Installing script: ' + options.src); */
			var script = $.extend(document.createElement('script'), options);
			var scripts = document.getElementsByTagName('script');
			scripts[0].parentNode.appendChild(script);
		}
	}

	function convertPlacesToModel(places) {
		var model = [];
		$.each(places, function (index, place) {
			/* console.log('Types: ' + JSON.stringify(place.types)); */
			if (place.types.includes('street_address') ||
				place.types.includes('intersection') ||
				place.types.includes('premise') ||
				place.types.includes('subpremise') ||
				place.types.includes('establishment') ||
				place.types.includes('point_of_interest')) {
				model.push(convertPlaceToModel(place));
			}
		});
		return model;
	}

	function convertPlaceToModel(place) {
		if (place) {
			/* console.log('[WarehouseSelector] Place: ' + JSON.stringify(place)); */
			return {
				Id: place.place_id,
				Address: place.formatted_address,
				AddressComponents: {
					StreetNumber: getAddressComponent(place.address_components, 'street_number'),
					StreetName: getAddressComponent(place.address_components, 'route'),
					Area: getAddressComponent(place.address_components, 'administrative_area_level_3'),
					City: getAddressComponent(place.address_components, 'locality'),
					Prefecture: getAddressComponent(place.address_components, 'administrative_area_level_2'),
					PostalCode: getAddressComponent(place.address_components, 'postal_code'),
					CountryCode: getAddressComponent(place.address_components, 'country')
				},
				Coordinates: {
					Latitude: place.geometry.location.lat,
					Longitude: place.geometry.location.lng
				},
				Viewport: {
					Northeast: {
						Latitude: place.geometry.viewport.northeast.lat,
						Longitude: place.geometry.viewport.northeast.lng
					},
					Southwest: {
						Latitude: place.geometry.viewport.southwest.lat,
						Longitude: place.geometry.viewport.southwest.lng
					}
				}
			};
		}
	}

	function getAddressComponent(components, fieldType) {
		var value = undefined;
		$.each(components, function (index, component) {
			if (component.types && component.types.includes(fieldType)) {
				value = component.short_name;
				return false;
			}
		});
		return value;
	}

	function convertDataToModel(data) {
		if (data) {
			return {
				Id: data.locationId,
				Address: data.locationAddress,
				AddressComponents: {
					StreetNumber: data.locationStreetNumber,
					StreetName: data.locationStreetName,
					Area: data.locationArea,
					City: data.locationCity,
					Prefecture: data.locationPrefecture,
					PostalCode: data.locationPostalCode,
					CountryCode: data.locationCountryCode
				},
				Coordinates: {
					Latitude: parseFloat(data.locationLatitude),
					Longitude: parseFloat(data.locationLongitude)
				}
			};
		}
	}
});
